import debounce from 'lodash/debounce';
import React, { useCallback, useState } from 'react';
import { ShortUnderlineInput } from 'swag-client-common/components/inputs/pink-underline-input';
import classes from './goodie-giveaway-product-quantity-input.scss';
const DEFAULT_MAX = 999;
const DEBOUNCE_INTERVAL = 1000;
export const GoodieGiveawayProductQuantityInput = ({
  onChange,
  quantity: initialQuantity,
  max = DEFAULT_MAX
}) => {
  const [quantity, setQuantity] = useState(initialQuantity.toString());
  const debouncedChangeValue = useCallback(debounce(onChange, DEBOUNCE_INTERVAL), []);
  const handleChange = e => {
    const {
      value
    } = e.target;
    const valueNumber = Number(value);
    const isValidNumber = !isNaN(valueNumber) && valueNumber <= max;
    if (!isValidNumber) {
      return;
    }
    setQuantity(value);
    if (valueNumber > 0) {
      debouncedChangeValue(valueNumber);
    }
  };
  const handleOnBlur = () => {
    if (!Number(quantity)) {
      setQuantity('1');
    }
    onChange(Number(quantity) || 1);
  };
  return /*#__PURE__*/React.createElement(ShortUnderlineInput, {
    dataInput: "ProductQuantity",
    value: quantity,
    onBlur: handleOnBlur,
    className: classes.underlinedInput,
    onChange: handleChange
  });
};